import React from 'react';
import { Control, Controller } from 'react-hook-form';

import { Input } from '@/components/Input';
import { InputWrapper } from '@/components/InputWrapper/InputWrapper';

import { FormFields, FormValues } from '../../types';

type CommentSectionProps = {
  control: Control<FormValues>;
};

export const CommentSection: React.FC<CommentSectionProps> = ({ control }) => {
  return (
    <InputWrapper label="Комментарий">
      <Controller
        control={control}
        name={FormFields.comment}
        render={({ field }) => (
          <Input {...field} placeholder="Введите комментарий (необязательно)" multiline rows={4} />
        )}
      />
    </InputWrapper>
  );
};
